import React from "react"
interface IconProps {
  data?: string
}
class MI_Ext extends React.Component<IconProps> {
  renderIcon = () => {
    return <></>
  }
  render() {
    const { data } = this.props
    return (
      <div className={`mi_${data?.replace("type:", "")}`}>
        {this.renderIcon()}
      </div>
    )
  }
}
export default MI_Ext
